export enum JobClosedCategory {
  filled_internally = "Filled internally",
  filled_with_external_agency = "Filled with an agency outside Hiring Hub",
  change_in_internal_circumstances = "Change in internal circumstances",
  insufficient_agencies = "Not enough agencies to support the role",
  poor_agency_performance = "Poor agency performance",
  change_in_job_specification = "Change in job specification",
  closing_to_repost = "Closing to repost",
  closed_by_hiring_hub = "Closed by Hiring Hub",
  other = "Other",
}

export type JobClosedCategoryKey = keyof typeof JobClosedCategory;
